var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgHourGlass = function SvgHourGlass(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_718_3895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.2 77.4001C67.8 82.7001 51 74.4001 45.8 59.0001L36.3 31.1001L92.2 12.1001L101.7 40.0001C106.9 55.4001 98.7 72.2001 83.2 77.4001Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2 83.1002C100.6 77.9002 117.4 86.1002 122.6 101.5L132.1 129.4L76.2 148.4L66.7 120.5C61.5 105.1 69.7 88.3002 85.2 83.1002Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9969 63.6598L73.3513 67.6167L83.2918 96.8728L94.9374 92.9159L84.9969 63.6598Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.2 15.7L32 38.8C28.9 39.9 25.5 38.2 24.4 35C23.3 32 25 28.6 28.2 27.5L96.3 4.30003C99.4 3.20003 102.8 4.90003 103.9 8.10003C105 11.2 103.3 14.6 100.2 15.7Z",
    fill: "#7BDDEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.1 133.1L71.9 156.3C68.8 157.4 65.4 155.7 64.3 152.5C63.2 149.4 64.9 146 68.1 144.9L136.3 121.7C139.4 120.6 142.8 122.3 143.9 125.5C144.9 128.6 143.2 132 140.1 133.1Z",
    fill: "#7BDDEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4 19.7002L43.9 34.8002L51.5 57.1002C55.7 69.3002 69 75.9002 81.3 71.8002C93.6 67.7002 100.2 54.2002 96 41.9002L88.4 19.7002Z",
    fill: "url(#paint0_linear_718_3895)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89 88.2L81.1 65L77.3 66.3L85.2 89.5C74.1 94.3 68.4 107 72.4 118.6L80 140.9L124.5 125.8L116.9 103.5C113 91.8 100.7 85.3 89 88.2Z",
    fill: "url(#paint1_linear_718_3895)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3 48.9998C56.3 48.9998 70.2 44.9998 77.8 36.8998C84.9 29.3998 91 27.2998 91 27.2998L95.2 39.6998L76.8 47.6998L56.3 48.9998Z",
    fill: "url(#paint2_linear_718_3895)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6 37.7002C61.9 52.6002 47.5 45.3002 47.5 45.3002L51.5 57.2002C55.7 69.3002 69 75.9002 81.3 71.8002C93.6 67.7002 100.2 54.2002 96 41.9002C96 41.9002 95.3 39.8002 94.6 37.7002Z",
    fill: "#FFD590"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7261 69.7254L78.9389 71.0122L91.8713 109.074L95.6585 107.787L82.7261 69.7254Z",
    fill: "#FFD590"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9 109.1C91.9 109.1 95.5 118.2 91 124C87.2 129 80.8 124.6 74.8 125.7C76 129.3 80 140.9 80 140.9L102.3 133.3L93.9 108.5L91.9 109.1Z",
    fill: "#FFD590"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7 107.8C95.7 107.8 99.1 119 106.1 120.9C112.2 122.5 115.8 117.7 122.9 120.9C124.1 124.5 124.5 125.7 124.5 125.7L102.2 133.3L93.8 108.5L95.7 107.8Z",
    fill: "#FFD590"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.8 67.4003C119.8 67.9003 119.2 69.0003 119.4 70.1003C119.4 70.3003 119.5 70.5003 119.6 70.6003C120.2 71.8003 121.6 72.3003 122.8 71.8003L128.3 69.2003C128.9 68.9003 129.3 68.4003 129.6 67.8003C129.8 67.3003 129.8 66.7003 129.6 66.2003C129.6 66.1003 129.5 66.0003 129.5 65.9003C128.9 64.7003 127.5 64.2003 126.3 64.7003L120.8 67.4003Z",
    fill: "#E1DFDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.5 82.0005C122.5 82.3005 122.5 82.5005 122.5 82.8005C122.7 83.8005 123.5 84.6005 124.6 84.7005L130.3 85.4005C130.9 85.5005 131.6 85.3005 132.1 84.9005C132.6 84.5005 132.9 83.9005 133 83.3005C133 82.9005 133 82.6005 132.9 82.2005C132.8 81.9005 132.7 81.7005 132.5 81.5005C132.1 81.0005 131.5 80.7005 130.9 80.6005L125.2 79.9005C124.6 79.8005 123.9 80.0005 123.4 80.4005C122.9 80.8005 122.6 81.3005 122.5 82.0005Z",
    fill: "#E1DFDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112 58.7002C111.8 59.2002 111.7 59.7002 111.8 60.3002C112 61.0002 112.4 61.7002 113.1 62.0002C114.3 62.6002 115.8 62.1002 116.4 60.9002L119.3 55.1002C119.6 54.5002 119.6 53.9002 119.4 53.3002C119.2 52.7002 118.8 52.2002 118.2 51.9002C117 51.3002 115.5 51.8002 114.9 53.0002L112 58.7002Z",
    fill: "#E1DFDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 133.2C37.732 133.2 44 126.932 44 119.2C44 111.468 37.732 105.2 30 105.2C22.268 105.2 16 111.468 16 119.2C16 126.932 22.268 133.2 30 133.2Z",
    fill: "#E1DFDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 112.9C40.6274 112.9 46 107.527 46 100.9C46 94.2725 40.6274 88.8999 34 88.8999C27.3726 88.8999 22 94.2725 22 100.9C22 107.527 27.3726 112.9 34 112.9Z",
    fill: "#E1DFDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 105.5C25.8 105.8 24.7 106.2 23.6 106.7C26.1 111.2 31.4 113.7 36.7 112.5C38.3 112.1 39.8 111.4 41.1 110.5C37.8 106.5 32.4 104.3 27 105.5Z",
    fill: "#C8C6C4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_718_3895",
    x1: 61.4532,
    y1: 13.3365,
    x2: 70.9695,
    y2: 41.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00021777,
    stopColor: "#797673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1DFDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_718_3895",
    x1: 125.818,
    y1: 145.119,
    x2: 71.9467,
    y2: 94.9053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#797673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1DFDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_718_3895",
    x1: 73.5301,
    y1: 47.7273,
    x2: 86.3884,
    y2: 28.6616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7B548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD590"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_718_3895"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128.2,
    height: 152.6,
    fill: "white",
    transform: "translate(16 4)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHourGlass);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/hour_glass.e34319fd.svg";